import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=22f666cb&scoped=true"
import script from "./LoginLayout.vue?vue&type=script&lang=ts"
export * from "./LoginLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f666cb",
  null
  
)

export default component.exports